// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WindowsFilledSvg from "@fishx/icons-svg/es/asn/WindowsFilled";
import FishxIcon from '../components/FishxIcon';

var WindowsFilled = function WindowsFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: WindowsFilledSvg
  }));
};

WindowsFilled.displayName = 'WindowsFilled';
export default React.forwardRef(WindowsFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/WindowsFilled.js
// module id = 4412
// module chunks = 0